import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const successMessage = (location.state as any)?.message as string | undefined;

  const from = (location.state as any)?.from?.pathname || '/dashboard';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await login({ email, password });
      navigate(from, { replace: true });
    } catch (err: any) {
      if (err?.status === 'unverified') {
        navigate('/verify-email-required', { state: { email } });
        return;
      }
      if (err?.status === 'affiliate_payment_required') {
        setError('Affiliate payment is pending. Complete payment from your email verification page, then sign in.');
        return;
      }
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="center">
        <div className="card shadow" style={{ maxWidth: '400px', width: '100%' }}>
          <div style={{ textAlign: 'center', marginBottom: '24px' }}>
            <h1 className="h1">Welcome Back</h1>
            <p className="muted">Sign in to your talixjobs account</p>
          </div>

          {error && (
            <div className="alert error">
              {error}
            </div>
          )}
          {successMessage && (
            <div className="alert success">
              {successMessage}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="label">Email</label>
              <input
                type="email"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email"
              />
            </div>

            <div className="form-group">
              <label className="label">Password</label>
              <div className="password-field">
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="Enter your password"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  <span className="eye-icon" aria-hidden="true">
                    {showPassword ? '\u{E801}' : '\u{E800}'}
                  </span>
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="btn"
              disabled={loading}
              style={{ width: '100%', margin: '16px 0' }}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div style={{ textAlign: 'center', marginBottom: '16px' }}>
            <Link to="/forgot-password">Forgot password?</Link>
          </div>

          <div style={{ textAlign: 'center', margin: '20px 0' }}>
            <span className="muted">Don't have an account? </span>
            <Link to="/register">Sign up here</Link>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Login;
